// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"77f8b899a891dcbe883a","691":"87dbd71444fba4a80cbf"}[chunkId] + ".js";
};